import qs from 'qs';

const workspaceUUIDForPath = (workspaceUUID?: string | null) => {
  if (!workspaceUUID) {
    return null;
  }

  return workspaceUUID.startsWith('{') && workspaceUUID.endsWith('}')
    ? workspaceUUID
    : `{${workspaceUUID}}`;
};

export const urls = {
  api: {
    internal: {
      billingCountries: (countryIsoCode?: string) => {
        const baseUrl = `/!api/internal/billing/country/`;
        if (countryIsoCode) {
          const params = qs.stringify({ country: countryIsoCode });
          return `${baseUrl}?${params}`;
        }
        return baseUrl;
      },
      billingCountriesTax: (countryIsoCode: string) =>
        `/!api/internal/billing/country/${countryIsoCode}/tax`,
      checkHamsTask: (taskId: string) => `/!api/internal/hams/task/${taskId}`,
      navigation: (): string => {
        return `/!api/internal/menu/account`;
      },
      stripeKey: (
        countryCode: string,
        currency: string,
        workspaceUUID?: string | null
      ) => {
        const workspaceUUIDPath = workspaceUUIDForPath(workspaceUUID);

        return workspaceUUIDPath
          ? `/!api/internal/workspaces/${workspaceUUIDPath}/stripe/stripe-key/${countryCode}/${currency}`
          : `/!api/internal/stripe/stripe-key/${countryCode}/${currency}`;
      },
      // TODO: currently gateway (STRIPE_US) needs to be hard-coded because the bb endpoint doesn't support
      // gateway as a query parameter and the HAMSCreditCardFormState doesn't support gateway as a part of
      // the route
      paymentMethodToken: (workspaceUUID?: string | null) => {
        const workspaceUUIDPath = workspaceUUIDForPath(workspaceUUID);

        return workspaceUUIDPath
          ? `/!api/internal/workspaces/${workspaceUUIDPath}/stripe/stripe-payment-method-token/STRIPE_US`
          : `/!api/internal/stripe/stripe-payment-method-token/STRIPE_US`;
      },
    },
    plan: (uuid: string, planSlug: string) =>
      `/account/user/${uuid}/upgrade-new/${planSlug}`,
  },
  ui: {
    createWorkspace: '/workspace/create/',
    updatePaymentMethod: (uuid: string) =>
      `/account/user/${uuid}/payment-response-new`,
  },
};
